import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'El framework de auditoría me salvó de tomar un cliente con margen del 15%. Imposible haber funcionado. Ahora solo acepto lo que tiene la estructura correcta.',
    author: 'Carla R.',
    location: 'Mendoza',
    role: 'MegaPack + Máster Estratega',
    initial: 'C'
  }, {
    quote: 'Con el banco de ganchos del Bono 4, en 10 minutos tengo 5 opciones de primera línea para testear. El CTR de mis campañas subió un 67% en el primer mes.',
    author: 'Roberto M.',
    location: 'Buenos Aires',
    role: 'Media Buyer',
    initial: 'R'
  }, {
    quote: 'Mis clientes de e-commerce por fin ven ROAS sostenido. El Tomo 4 de Data & Profit Analysis cambió completamente cómo tomo decisiones.',
    author: 'Sofía C.',
    location: 'La Plata',
    role: 'Freelancer Meta Ads',
    initial: 'S'
  }, {
    quote: 'El planner semanal del Bono 5 fue un antes y un después. Recuperé 15 horas semanales y mejoré los resultados de todos mis clientes al mismo tiempo.',
    author: 'Pablo A.',
    location: 'Rosario',
    role: 'Agencia Digital',
    initial: 'P'
  }];
  const Stars = () => <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-328">
      {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-329" />)}
    </div>;
  return <section className="py-14 px-4 max-w-6xl mx-auto bg-black" data-id="element-330">
      <FadeIn data-id="element-331">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-332">
          <span className="text-red-500" data-id="element-333">❤️</span> MÁS COMPRADORES QUE YA LO
          TIENEN
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-334">
        {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-335">
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-8 h-full flex flex-col" data-id="element-336">
              <Stars data-id="element-337" />
              <p className="text-lg text-gray-200 mb-6 italic leading-relaxed flex-grow" data-id="element-338">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-339">
                <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 font-bold shrink-0" data-id="element-340">
                  {t.initial}
                </div>
                <div data-id="element-341">
                  <p className="font-bold text-white" data-id="element-342">{t.author}</p>
                  <p className="text-sm text-gray-500" data-id="element-343">
                    {t.location} | {t.role}
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}